const UNITS = ["B", "KB", "MB", "GB", "TB"];

/**
 * Formata um tamanho em bytes para a unidade legível mais próxima (base 1024).
 * Ex.: 1536 → "1,5 KB"; 0 → "0 B"; undefined → "—".
 */
export function formatBytes(bytes?: number | null, decimals = 1): string {
  if (bytes == null || Number.isNaN(bytes)) return "—";
  if (bytes <= 0) return "0 B";

  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), UNITS.length - 1);
  const value = bytes / Math.pow(1024, i);
  // Bytes inteiros não precisam de casas decimais.
  const formatted = i === 0 ? value.toString() : value.toFixed(decimals);

  return `${formatted.replace(".", ",")} ${UNITS[i]}`;
}
